export enum StreamType {
	PeerToPeer = 'Peer-to-Peer',
	Multicast = 'Multicast',
	DMECache = 'DME Cache',
	VbrickCloud = 'Vbrick Cloud',
	Origin = 'Origin'
}
